import PDF from './pdf'
import { capitalizeFirstLetter } from '../lib/utils'

export default class LoanReport extends PDF {
  /**
   * Description
   * @param {import('jspdf').DocumentProperties} args
   */
  constructor(args = {}) {
    super()
    this.doc.setProperties({
      unit: 'mm',
      format: 'a4',
      ...args,
    })
    this.addFonts()
  }

  /**
   * Description
   * @param {boolean} [cancel]
   */
  __header({ storeName = '', dateRange = '' }) {
    const title = `${capitalizeFirstLetter(storeName)} Report`
    this.centerText({ fontSize: 24, text: title, yOffset: 15, color: [55, 71, 79] })
    this.centerText({ fontSize: 12, text: 'Accounts Receivable', yOffset: 22, color: [55, 71, 79] })
    this.centerText({ fontSize: 12, text: dateRange, yOffset: 27 })
    this.doc.setFillColor('#CFD8DC')
    this.doc.line(15, 30, 195, 30, 'F')
  }

  /**
   * Description
   * @param {HeadingData} subHeader
   * @returns {void}
   */
  __subHeader(subHeader) {
    const { totalAmount = '', balance = '', totalPaid = '' } = subHeader || {}
    const [x, y] = [15, 40]
    const delimiter = ':'

    const { labelWidth: textLength } = this.generateField({
      label: 'Accounts Receivable',
      value: totalAmount,
      coordinates: [x, y],
      lineLength: 0,
      delimiter,
    })

    this.generateField({
      label: 'Unpaid Balance',
      value: balance,
      coordinates: [x, y + 10],
      textLength,
      lineLength: 0,
      delimiter,
    })

    this.generateField({
      label: 'Paid',
      value: totalPaid,
      coordinates: [x, y + 5],
      textLength,
      lineLength: 0,
      delimiter,
    })
  }

  /**
   * Description
   * @param {{ totalAmount: number; }} params
   * @param {ReceiptItem} body
   * @returns {any}
   */
  __table(_, body) {
    this.doc.autoTable({
      head: [['Receipt#', 'Name', 'Due', 'Date', 'Amnt', 'Balance', 'Paid', 'Remarks']],
      startY: 60,
      body: [
        ...body,
      ],
    })
  }

  /**
   * Description
   * @param {string} receiptNo
   * @returns {void}
   */
  __save(storeName) {
    const name = `${storeName}_loan_reports_${new Date().getTime()}`.replace(/[\s]+/g, '_')
    this.doc.save(name)
  }

  /**
   * Description
   * @param {HeadingData} data
   * @param {ReceiptItem[]} items
   * @returns {any}
   */
  generate(data, items) {
    this.__header(data)
    this.__subHeader(data)
    this.__table(data, items)
    this.__save(data.storeName)
  }
}

/**
 * @typedef HeadingData
 * @property {number} storeName
 * @property {string} dateRange
 * @property {string} totalAmount
 * @property {number} balance
 * @property {string} totalPaid
 * 
 * @typedef Items
 * @property {string} receiptNo
 * @property {number} name
 * @property {string} dateDue
 * @property {string} dateLoaned
 * @property {string} amount
 * @property {string} balance
 * @property {string} remarks
 */
